export default __webpack_public_path__ + "static/media/bg.9cc90562.jpg";